import http from '@/lib/admin/http'
import {Message, MessageBox} from 'element-ui'

export default {
  namespaced: true,
  state: {
    url: '/api/admin/about',
    createUrl: '/api/admin/about',
    list: [],
    newAbout: {},
    About: {},
    loading: false,
    ruleForm:{},
    rules: {
      title: [{required: true, message: '请输入标题', trigger: 'blur'},{ max:35, message: '最多输入35个字符', trigger: 'blur' }],
      development: [{required: true, message: '请输入开发协作', trigger: 'blur'},{ max:40, message: '最多输入40个字符', trigger: 'blur' }],
      joint: [{required: true, message: '请输入联合推广', trigger: 'blur'},{ max:20, message: '最多输入20个字符', trigger: 'blur' }],
      copyright: [{required: true, message: '请输入版权所有', trigger: 'blur'},{ max:20, message: '最多输入20个字符', trigger: 'blur' }],
    },
    content:"",
  },
  mutations: {
    loading(state) {
      state.loading = true;
    },
    closeLoading(state) {
      state.loading = false;
    },
    resetCreate(state) {
      state.newAbout = {};
    },
    setAbout(state, About) {
      state.About = About;
    },
    resetAbout(state) {
      state.About = {}
    },
    setContent(state, content) {
      state.content = content;
    }
  },
  actions: {
    /**
     * 获取详情
     * @param  context
     * @param  about
     * @returns  {Promise<any>}
     */
    show(context, about) {
      return new Promise((success, faild) => {
        context.commit('resetAbout');
        http.getData(context.state.url + '/' + about.id, about)
            .then(res => {
              context.commit('setAbout', res.data.data);
              context.commit('setContent', res.data.data.content);
              success(res.data);
            })
            .catch(res => {
              context.commit('closeLoading');
              faild()
            });
      })
    },

    /**
     * 更新
     * @param  context
     * @param  About
     * @returns  {Promise<any>}
     */
    update(context) {
      return new Promise((success, faild) => {
        http.putData(context.state.url + '/' + context.state.About.id, context.state.About)
            .then(res => {
              if (res.result.code == 1) {
                success(res.data);
              } else {
                Message.error(res.result.message);
              }
            }).catch(faild)
        ;
      })
    },
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/vuex/modules/admin/about.js